import React from 'react';
import styled from 'styled-components';
import { Box, Heading, Text } from 'rebass';
import { withRouter } from 'react-router-dom';
import { useEffect } from 'react';
import withSession from '../lib/withSession';

const Container = styled(Box)`
  max-width: 650px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  padding-top: 24px;
  position: relative;
`;

const ScheduleNutritionistGi = withSession(
  withRouter(({ history, session }) => {
    useEffect(() => {
      if (!session || !session.eligibility.canBookNutritionist || !session.isGiMember) {
        history.push('/');
      } else {
        const script = document.createElement('script');
        script.src = 'https://assets.calendly.com/assets/external/widget.js';
        script.async = true;

        document.body.appendChild(script);
      }
    });
    const { email, firstName, lastName } = session;
    const name = encodeURI(`${firstName} ${lastName}`);
    let url = `https://calendly.com/paloma-video-visit/gut-reset?hide_event_type_details=1&name=${name}&email=${email}`;
    return (
      <Container>
        <Heading mb={4} style={{ fontSize: '23px' }}>
          Book your next nutrition session
        </Heading>
        <Text>Your nutritionist will help you review your symptoms, track improvements, and adjust your GI program as needed.</Text>

        <div
          className="calendly-inline-widget"
          data-url={url}
          style={{
            minWidth: '320px',
            width: '350px',
            margin: '24px auto',
            height: '600px',
          }}
        />

        <Text
          mt={4}
          textAlign={'center'}
          alignSelf={'center'}
          style={{ color: '#44A5FF', fontSize: '14px', cursor: 'pointer' }}
          onClick={() => {
            history.push('/programs/gut-reset');
          }}
        >
          {`Go to your GI program >`}
        </Text>
      </Container>
    );
  })
);

export default ScheduleNutritionistGi;
